
import authService from "@/api/authService";
import menuService from "@/api/menuService";
import MessageService from "@/utils/message";
import tokenService from "@/utils/tokenService";
import { onActivated, onMounted, reactive, toRaw } from "vue";
import { Options, setup, Vue } from "vue-class-component";
import { LockOutlined, UserOutlined } from "@ant-design/icons-vue";
import { useRouter } from "vue-router";
import { notification } from "ant-design-vue";
import { useStore } from "vuex";
import {RuleObject} from "ant-design-vue/es/form/interface";
const menuJson = require("@/assets/js/menu.json");

let context:any;
@Options({
  components: {
    LockOutlined,
    UserOutlined,
    notification,
  },
})

export default class Login extends Vue {
  created() {
    context = this;
  }

  loginInfo = setup(() => {
    const router = useRouter();
    const store = useStore();
    const loginUserInfo = reactive({
      user: "",
      password: "",
    });

    const handleLoginSubmit = () => {
      // getMenuList();
      authService.login(loginUserInfo.user, loginUserInfo.password).then(
        (result) => {
          tokenService.setToken(result.data.token);

          // let judgeMsg = judgeResetPassword(loginUserInfo.password);
          // if (judgeMsg) {
          //   MessageService.info(judgeMsg);
          //   // 需要修改密码, 获取用户userId
          //   context.pwdChangeInfo.getUserInfo(loginUserInfo.password);
          //   return;
          // }

          // 不需要修改密码
          // authService.getMyConstructionParkInfoList().then((result: any) => {
          //   let parkInfoList = result.result;
          //   store.commit("setParkInfoList", parkInfoList);
          //   if (!parkInfoList.length) {
          //     MessageService.error("获取园区信息失败，禁止登录！");
          //     return;
          //   }
          //   getMenuList();
          // });

           store.commit("setParkInfoList", [{id:1}]);

           getMenuList();
        },
        (err) => {
          console.log(err);
          if (err === 401) {
            MessageService.error("账号或密码错误！登录失败！");
          }
        }
      );
    };

    const getMenuList = () => {
      // let menuList:any = menuJson[0].data;
      // store.commit('setMenuList', menuList);
      // MessageService.info("登录成功，即将跳转！");
      // setTimeout(() => {
      //   router.replace("/workbench");
      // }, 200);
      menuService.getMenuList().then((result: any) => {
        let menuList = result.result;
        if (menuList.length === 0) {
          MessageService.error("您没有权限访问,请联系管理员开通相关权限！");
          return;
        }
        store.commit("setMenuList",[{data:menuList}]);
        MessageService.info("登录成功，即将跳转！");
        console.log(result);
        setTimeout(() => {
          router.replace("/workbench");
        }, 500);
      });
    };

    const openNotificationWithIcon = () => {
      notification.info({
        message: "提示信息",
        description: "需要修改密码请联系管理员！",
        onClick: () => {
          console.log("Notification Clicked!");
        },
      });
    };

    // 判断是否需要修改密码
    const judgeResetPassword = (password: string) => {
      let msg = "";
      if(password == 'Wxsk.sxc.account.16'){
        msg = "首次登录，请修改初始默认密码"
      }else if(!regTest(password)){
        msg = '由于密码过于简单，请修改密码后登录'
      }
      return msg;
    };

    // 正则表达式判断
    const regTest = (str: string) => {
      let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*.?&])[A-Za-z\d$@$!%*.?&]{8,}/;
      // let reg = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,30}$");
      return reg.test(str);
    };

    onMounted(()=>{
      // getMenuList();
    })

    return {
      loginUserInfo,
      handleLoginSubmit,
      openNotificationWithIcon,
    };
  });

  pwdChangeInfo = setup(()=>{
    const resetPwdUserInfo = reactive({
      id: "",
      oldPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    });
    let validateForm: any;

    const pwdMatchReg = async (rule: any, user: any) => {
      let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*.?&])[A-Za-z\d$@$!%*.?&]{8,}/;
      if(reg.test(user)){
        return Promise.resolve();
      }else{
        return Promise.reject("密码不符合规则, 请输入8~30位, 字母大小写+数字+特殊字符的组合");
      }
    };
    const pwdIsSame = async (rule: any, user: any) => {
      if(resetPwdUserInfo.newPassword == resetPwdUserInfo.confirmNewPassword){
        return Promise.resolve();
      }else{
        return Promise.reject("两次密码输入不一致");
      }
    };
    const rules = reactive({
      newPassword: [
        {required: true, message: '请输入新密码', trigger: 'blur'},
        {validator: pwdMatchReg, required: true, trigger: ['change', 'blur'],}
      ],
      confirmNewPassword: [
        {required: true, message: '请确认输入新密码', trigger: 'blur'},
        {validator: pwdIsSame, required: true, trigger: ['change', 'blur'],}
      ],
    });


    const modalConfig = reactive({
      visible: false,
    }); // 修改密码弹窗样式


    const getUserInfo = (pwd: any) => {
      authService.getLoginUserInfo().then((result: any) => {
        let userInfo = result;
        resetPwdUserInfo.id = userInfo.userId;
        resetPwdUserInfo.oldPassword = pwd;
        modalConfig.visible = true;
      });
    };

    const handleResetClose = () => {
      resetPwdUserInfo.newPassword = "";
      resetPwdUserInfo.confirmNewPassword = "";
      modalConfig.visible = false;
    };

    const handleResetConfirm = () => {
      validateForm.validate().then(() => {
        let info: any = toRaw(resetPwdUserInfo);
        authService.updatePwd(info).then((result:any) => {
          if(result.status == 200){
            MessageService.success("密码修改成功，请重新登录")
            resetPwdUserInfo.newPassword = "";
            resetPwdUserInfo.confirmNewPassword = "";
            modalConfig.visible = false;
          }else{
            MessageService.error(result.message);
          }
        });
      })
      .catch((error: any) => {
        console.log(error);
      });
    };

    const setValidateForm = (el: any) => {
      console.log('setValidateForm', el);
      validateForm = el;
    }

    return {
      resetPwdUserInfo,
      modalConfig,
      rules,
      getUserInfo,
      handleResetClose,
      handleResetConfirm,
      setValidateForm,
    };
  })

}
